<template>
  <a-locale-provider :locale="locale">
    <slot />
  </a-locale-provider>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale-provider/zh_CN'

export default {
  name: 'LocaleProviderx',
  props: {
    locale: {
      type: Object,
      default: () => zhCN
    }
  }
}
</script>

<style scoped>

</style>
